// Course-related routes module
import Activity from '@/router/courses/activities/Activity.js';
import Discussion from '@/router/courses/activities/Discussion.js';
import ActivityGrader from '@/router/courses/activity-grader/ActivityGrader.js';
import CourseAttemptAuthorizations from '@/router/courses/attempt-authorizations/CourseAttemptAuthorizations.js';
import CourseAttendance from '@/router/courses/attendance/CourseAttendance.js';
import Courses from '@/router/courses/Courses.js';
import CourseEnrollments from '@/router/courses/enrollments/Enrollments.js';
import CourseGradebookPreview from '@/router/courses/gradebook/CourseGradebookPreview.js';
import Gradebook from '@/router/courses/gradebook/Gradebook.js';
import CourseMeetings from '@/router/courses/meetings/CourseMeetings.js';
import CourseObjectives from '@/router/courses/objectives/Objective.js';
import Quiz from '@/router/courses/quizzes/Quiz.js';
import StudentGrade from '@/router/courses/student/student-grade/StudentGrade.js';
import Survey from '@/router/courses/surveys/Survey.js';

export default [
    ...Activity,
    ...Discussion,
    ...ActivityGrader,
    ...CourseAttemptAuthorizations,
    ...CourseAttendance,
    ...Courses,
    ...CourseEnrollments,
    ...CourseGradebookPreview,
    ...Gradebook,
    ...CourseMeetings,
    ...CourseObjectives,
    ...Quiz,
    ...StudentGrade,
    ...Survey,
];
